import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import IncentiveList, { DispatchProps, OwnProps, StateProps } from './IncentiveList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getIncentives } from 'src/store/actions/incentive-actions';
import { getIncentivesCsv } from 'src/store/actions/incentive-actions';
import { getIncentivesInFile } from 'src/store/actions/incentive-actions';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.incentives.data,
        inProgress: state.incentives.inProgress,
        providers: selectNameProviders(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getDataCsv: (params: QueryParams) => dispatch(getIncentivesCsv(params)),
        getDataInFile: (params: QueryParams) => dispatch(getIncentivesInFile(params)),
        getData: (params: QueryParams) => dispatch(getIncentives(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
    };
}

const IncentiveListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(IncentiveList);

export default IncentiveListScreen;
